// DO NOT EDIT THIS FILE DIRECTLY. Autogenerated by "pnpm --filter @bazaar-marketplace/assets svgr:generate"
import { cn, isKeyOf } from '@bazaar-marketplace/utils';
import dynamic from 'next/dynamic';

import { IconSuspense } from '../loading/icon-suspense';

export type IconName =
  | 'alert-triangle'
  | 'align-right'
  | 'burn-flame'
  | 'candlestick'
  | 'check-circle'
  | 'check'
  | 'chevron-left'
  | 'chevron-right'
  | 'claiming-common'
  | 'claiming-rare'
  | 'claiming-secret-rare'
  | 'claiming-ultra-rare'
  | 'claiming-uncommon'
  | 'clock-stopwatch'
  | 'coins'
  | 'copy'
  | 'deposit-check'
  | 'disconnect-wallet'
  | 'disconnect'
  | 'external-indicator'
  | 'flash'
  | 'flip-backward'
  | 'forge-hammer'
  | 'goodies-logo'
  | 'hourglass'
  | 'leaderboard'
  | 'loading-03'
  | 'lock-04'
  | 'mint-circle'
  | 'minus'
  | 'participate'
  | 'plus-circle'
  | 'plus'
  | 'refresh'
  | 'scan'
  | 'share-04'
  | 'share-06'
  | 'share'
  | 'shopping-bag'
  | 'star-06'
  | 'star'
  | 'stars-03'
  | 'step-5-background'
  | 'sticker-circle'
  | 'sticker'
  | 'target-04'
  | 'task-check'
  | 'telegram-star'
  | 'tiny-ton'
  | 'ton'
  | 'trend-up'
  | 'users-2'
  | 'users-plus'
  | 'users'
  | 'verified'
  | 'wallet-02'
  | 'wallet-05'
  | 'wallet-connect'
  | 'wallet'
  | 'x-close'
  | 'x-logo';

const icons = {
  'alert-triangle': dynamic(() => import('./alert-triangle').then((module_) => module_.default)),
  'align-right': dynamic(() => import('./align-right').then((module_) => module_.default)),
  'burn-flame': dynamic(() => import('./burn-flame').then((module_) => module_.default)),
  candlestick: dynamic(() => import('./candlestick').then((module_) => module_.default)),
  'check-circle': dynamic(() => import('./check-circle').then((module_) => module_.default)),
  check: dynamic(() => import('./check').then((module_) => module_.default)),
  'chevron-left': dynamic(() => import('./chevron-left').then((module_) => module_.default)),
  'chevron-right': dynamic(() => import('./chevron-right').then((module_) => module_.default)),
  'claiming-common': dynamic(() => import('./claiming-common').then((module_) => module_.default)),
  'claiming-rare': dynamic(() => import('./claiming-rare').then((module_) => module_.default)),
  'claiming-secret-rare': dynamic(() => import('./claiming-secret-rare').then((module_) => module_.default)),
  'claiming-ultra-rare': dynamic(() => import('./claiming-ultra-rare').then((module_) => module_.default)),
  'claiming-uncommon': dynamic(() => import('./claiming-uncommon').then((module_) => module_.default)),
  'clock-stopwatch': dynamic(() => import('./clock-stopwatch').then((module_) => module_.default)),
  coins: dynamic(() => import('./coins').then((module_) => module_.default)),
  copy: dynamic(() => import('./copy').then((module_) => module_.default)),
  'deposit-check': dynamic(() => import('./deposit-check').then((module_) => module_.default)),
  'disconnect-wallet': dynamic(() => import('./disconnect-wallet').then((module_) => module_.default)),
  disconnect: dynamic(() => import('./disconnect').then((module_) => module_.default)),
  'external-indicator': dynamic(() => import('./external-indicator').then((module_) => module_.default)),
  flash: dynamic(() => import('./flash').then((module_) => module_.default)),
  'flip-backward': dynamic(() => import('./flip-backward').then((module_) => module_.default)),
  'forge-hammer': dynamic(() => import('./forge-hammer').then((module_) => module_.default)),
  'goodies-logo': dynamic(() => import('./goodies-logo').then((module_) => module_.default)),
  hourglass: dynamic(() => import('./hourglass').then((module_) => module_.default)),
  leaderboard: dynamic(() => import('./leaderboard').then((module_) => module_.default)),
  'loading-03': dynamic(() => import('./loading-03').then((module_) => module_.default)),
  'lock-04': dynamic(() => import('./lock-04').then((module_) => module_.default)),
  'mint-circle': dynamic(() => import('./mint-circle').then((module_) => module_.default)),
  minus: dynamic(() => import('./minus').then((module_) => module_.default)),
  participate: dynamic(() => import('./participate').then((module_) => module_.default)),
  'plus-circle': dynamic(() => import('./plus-circle').then((module_) => module_.default)),
  plus: dynamic(() => import('./plus').then((module_) => module_.default)),
  refresh: dynamic(() => import('./refresh').then((module_) => module_.default)),
  scan: dynamic(() => import('./scan').then((module_) => module_.default)),
  'share-04': dynamic(() => import('./share-04').then((module_) => module_.default)),
  'share-06': dynamic(() => import('./share-06').then((module_) => module_.default)),
  share: dynamic(() => import('./share').then((module_) => module_.default)),
  'shopping-bag': dynamic(() => import('./shopping-bag').then((module_) => module_.default)),
  'star-06': dynamic(() => import('./star-06').then((module_) => module_.default)),
  star: dynamic(() => import('./star').then((module_) => module_.default)),
  'stars-03': dynamic(() => import('./stars-03').then((module_) => module_.default)),
  'step-5-background': dynamic(() => import('./step-5-background').then((module_) => module_.default)),
  'sticker-circle': dynamic(() => import('./sticker-circle').then((module_) => module_.default)),
  sticker: dynamic(() => import('./sticker').then((module_) => module_.default)),
  'target-04': dynamic(() => import('./target-04').then((module_) => module_.default)),
  'task-check': dynamic(() => import('./task-check').then((module_) => module_.default)),
  'telegram-star': dynamic(() => import('./telegram-star').then((module_) => module_.default)),
  'tiny-ton': dynamic(() => import('./tiny-ton').then((module_) => module_.default)),
  ton: dynamic(() => import('./ton').then((module_) => module_.default)),
  'trend-up': dynamic(() => import('./trend-up').then((module_) => module_.default)),
  'users-2': dynamic(() => import('./users-2').then((module_) => module_.default)),
  'users-plus': dynamic(() => import('./users-plus').then((module_) => module_.default)),
  users: dynamic(() => import('./users').then((module_) => module_.default)),
  verified: dynamic(() => import('./verified').then((module_) => module_.default)),
  'wallet-02': dynamic(() => import('./wallet-02').then((module_) => module_.default)),
  'wallet-05': dynamic(() => import('./wallet-05').then((module_) => module_.default)),
  'wallet-connect': dynamic(() => import('./wallet-connect').then((module_) => module_.default)),
  wallet: dynamic(() => import('./wallet').then((module_) => module_.default)),
  'x-close': dynamic(() => import('./x-close').then((module_) => module_.default)),
  'x-logo': dynamic(() => import('./x-logo').then((module_) => module_.default)),
};

export const IconNameSet = new Set(Object.keys(icons));

export interface IconProps extends Omit<React.SVGProps<SVGSVGElement>, 'ref'> {
  name?: IconName;
  tryName?: string;
  size?: number | string;
  disableDefaultSize?: boolean;
}

export const Icon = (props: IconProps) => {
  const { name, tryName, size, width, height, disableDefaultSize, className, ...rest } = props;

  const defaultSize = disableDefaultSize ? undefined : (size ?? '1.25rem');

  const iconName = name ?? tryName;

  const IconComponent = iconName && isKeyOf(iconName, icons) ? icons[iconName] : undefined;

  if (!IconComponent) return null;
  return (
    <IconSuspense size={defaultSize}>
      <IconComponent
        aria-label={name}
        className={cn('shrink-0', className)}
        height={height ?? defaultSize}
        width={width ?? defaultSize}
        {...rest}
      />
    </IconSuspense>
  );
};
